"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

type ViewMode = "editorial" | "agency";

interface ViewModeContextType {
    mode: ViewMode;
    setMode: (mode: ViewMode) => void;
    toggleMode: () => void;
}

const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined);

export function ViewModeProvider({ children }: { children: ReactNode }) {
    const [mode, setMode] = useState<ViewMode>("editorial");

    const toggleMode = () => {
        setMode((prev) => (prev === "editorial" ? "agency" : "editorial"));
    };

    return (
        <ViewModeContext.Provider value={{ mode, setMode, toggleMode }}>
            {children}
        </ViewModeContext.Provider>
    );
}

export function useViewMode() {
    const context = useContext(ViewModeContext);
    if (context === undefined) {
        throw new Error("useViewMode must be used within a ViewModeProvider");
    }
    return context;
}
